import { setSaveStepsAction as setSaveStepsOperation } from 'editor/src/store/editorModules/undoRedo/slice';

export default setSaveStepsOperation;
